<template>
  <v-card ref="tabPlanification" color="transparent" flat light>
    <v-card-text>
      <v-container py-0>
        <!-- Seccion partidos -->
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $tc('models.match', 2) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2" />
        <v-layout row wrap>
          <v-flex md6 xs12 px-2>
            <pitch-field
              v-model="localMatch.stadiumMatch"
              v-validate="'required'"
              :team-id="team._id"
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.location'),
                })
              "
              :error-messages="errors.collect($tc('fields.global.location'))"
              :data-vv-name="$tc('fields.global.location')"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-menu
              ref="menuTimeMatch"
              v-model="menuTimeMatch"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="localMatch.startMatch"
                  v-validate="'required'"
                  prepend-icon="access_time"
                  readonly
                  :label="$tc('fields.global.startAtTime') + ' (*)'"
                  :data-vv-name="$tc('fields.global.startAtTime')"
                  :error-messages="
                    errors.collect($tc('fields.global.startAtTime'))
                  "
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="menuTimeMatch"
                v-model="localMatch.startMatch"
                full-width
                @click:minute="$refs.menuTimeMatch.save(localMatch.startMatch)"
              />
            </v-menu>
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="localMatch.endMatch"
              prepend-icon="access_time"
              disabled
              :label="$tc('fields.global.endAtTime') + ' (*)'"
              :data-vv-name="$tc('fields.global.endAtTime')"
              :error-messages="errors.collect($tc('fields.global.endAtTime'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-autocomplete
              v-model="localMatch.matchWeek"
              v-validate="'required'"
              :items="week"
              chips
              deletable-chips
              small-chips
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.week.days'),
                })
              "
              multiple
            />
          </v-flex>
        </v-layout>
        <!-- Seccion Entrenamientos -->
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $tc('models.training', 2) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2" />
        <v-layout row wrap>
          <v-flex md6 xs12 px-2>
            <pitch-field
              v-model="localMatch.stadiumTraining"
              v-validate="'required'"
              :team-id="team._id"
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.location'),
                })
              "
              :error-messages="errors.collect($tc('fields.global.location'))"
              :data-vv-name="$tc('fields.global.location')"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="localMatch.durationTraining"
              v-validate="'required'"
              :label="$tc('fields.matches.trainingDuration') + ' (*)'"
              :data-vv-name="$tc('fields.matches.trainingDuration')"
              :error-messages="
                errors.collect($tc('fields.matches.trainingDuration'))
              "
              type="number"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-menu
              ref="menuTimeTraining"
              v-model="menuTimeTraining"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="localMatch.startTraining"
                  v-validate="'required'"
                  :disabled="localMatch.durationTraining === ''"
                  prepend-icon="access_time"
                  readonly
                  :label="$tc('fields.global.startAtTime') + ' (*)'"
                  :data-vv-name="$tc('fields.global.startAtTime')"
                  :error-messages="
                    errors.collect($tc('fields.global.startAtTime'))
                  "
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="menuTimeTraining"
                v-model="localMatch.startTraining"
                full-width
                @click:minute="
                  $refs.menuTimeTraining.save(localMatch.startTraining)
                "
              />
            </v-menu>
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="localMatch.endTraining"
              prepend-icon="access_time"
              disabled
              :label="$tc('fields.global.endAtTime') + ' (*)'"
              :data-vv-name="$tc('fields.global.endAtTime')"
              :error-messages="errors.collect($tc('fields.global.endAtTime'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-autocomplete
              v-model="localMatch.trainingWeek"
              v-validate="'required'"
              :items="week"
              chips
              deletable-chips
              small-chips
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.week.days'),
                })
              "
              multiple
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <template>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
      </template>
      <v-spacer />
      <template>
        <meta-button type="update" :loading="loading" @click="submit()" />
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import PitchField from '@/components/widgets/Input/PitchField'
export default {
  components: {
    PitchField,
  },
  props: {
    entityId: {
      type: String,
      required: true,
      default: '',
    },
    team: {
      type: Object,
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      menuTimeMatch: false,
      menuTimeTraining: false,
      loading: false,
    }
  },
  computed: {
    localMatch: {
      get() {
        return this.team
      },
      set(value) {
        this.$emit('update:team', value)
      },
    },
    week() {
      return [
        {
          value: 0,
          text: this.$t('fields.global.week.sunday'),
        },
        {
          value: 1,
          text: this.$t('fields.global.week.monday'),
        },
        {
          value: 2,
          text: this.$t('fields.global.week.tuesday'),
        },
        {
          value: 3,
          text: this.$t('fields.global.week.wednesday'),
        },
        {
          value: 4,
          text: this.$t('fields.global.week.thursday'),
        },
        {
          value: 5,
          text: this.$t('fields.global.week.friday'),
        },
        {
          value: 6,
          text: this.$t('fields.global.week.saturday'),
        },
      ]
    },
  },
  watch: {
    'localMatch.startMatch'(newValue) {
      this.localMatch.endMatch = this.onChangeStartAtTime(
        newValue,
        this.team.matchesDuration ? this.team.matchesDuration : 90
      )
    },
    'localMatch.startTraining'(newValue) {
      this.localMatch.endTraining = this.onChangeStartAtTime(
        newValue,
        this.localMatch.durationTraining
      )
    },
  },
  methods: {
    ...mapActions({
      setUpdate: 'teams/update',
    }),
    onChangeStartAtTime(time, minToAdd) {
      function D(J) {
        return (J < 10 ? '0' : '') + J
      }
      let piece = time.split(':')
      let mins = piece[0] * 60 + +piece[1] + +minToAdd

      return D(((mins % (24 * 60)) / 60) | 0) + ':' + D(mins % 60)
    },
    convertHStoMS(hour) {
      var timeParts = hour.split(':')
      return +timeParts[0] * (60000 * 60) + +timeParts[1] * 60000
    },
    submit() {
      this.$nextTick(() => {
        this.$refs.tabPlanification.validate().then((valid) => {
          let payload = {
            _id: this.team._id,
            sheet: {
              stadiumMatch: this.localMatch.stadiumMatch,
              stadiumTraining: this.localMatch.stadiumTraining,
              durationTraining: this.localMatch.durationTraining,
              scheduleMatch: [
                {
                  startTimeMs: this.convertHStoMS(this.localMatch.startMatch),
                  endTimeMs: this.convertHStoMS(this.localMatch.endMatch),
                  dayOfWeek: this.localMatch.matchWeek.sort()[0],
                  repeatDayOfWeek: this.localMatch.matchWeek.sort(),
                },
              ],
              scheduleTraining: [
                {
                  startTimeMs: this.convertHStoMS(
                    this.localMatch.startTraining
                  ),
                  endTimeMs: this.convertHStoMS(this.localMatch.endTraining),
                  dayOfWeek: this.localMatch.trainingWeek.sort()[0],
                  repeatDayOfWeek: this.localMatch.trainingWeek.sort(),
                },
              ],
            },
          }
          if (!valid) return
          this.setUpdate(payload)
        })
      })
    },
  },
  mounted() {
    if (this.edit) {
      this.localMatch = this.team.sheet
      if (this.team.sheet) {
        this.localMatch.startMatch = `${moment(
          this.team.sheet.scheduleMatch[0].startTimeMs
        ).hour()}:${moment(
          this.team.sheet.scheduleMatch[0].startTimeMs
        ).minute()}`
        this.localMatch.startTraining = `${moment(
          this.team.sheet.scheduleTraining[0].startTimeMs
        ).hour()}:${moment(
          this.team.sheet.scheduleTraining[0].startTimeMs
        ).minute()}`
        this.localMatch.matchWeek =
          this.team.sheet.scheduleMatch[0].repeatDayOfWeek
        this.localMatch.matchWeek =
          this.team.sheet.scheduleTraining[0].repeatDayOfWeek
      }
    }
  },
}
</script>

<style></style>
